import { useDataSubmit, useDataValue } from 'Simple/Data.js'

export function useOnAddClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return async function onClick() {
    await submit({
      type: 'open_new_task_overlay',
      stage_id: props.stageId,
    })
  }
}

export function useOnToggleSubscribeClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let user_id = useDataValue({
    context: 'global',
    viewPath: props.viewPath,
    path: 'user.id',
  })

  return async function onClick() {
    if (props.isCurrentUserSubscribed) {
      await submit({
        type: 'delete_stage_subscriber',
        stage_id: props.stageId,
        user_id,
      })
    } else {
      await submit({
        type: 'create_stage_subscriber',
        stage_id: props.stageId,
        user_id,
      })
    }
  }
}
